<script lang="ts">
	import { footerPath } from '$lib/footer/store';
	import MarketsMobile from '$lib/markets/MarketsMobile.svelte';
	import Portfolio from '$lib/portfolio/Portfolio.svelte';

	$footerPath = '';

	let innerWidth: any;
	let innerHeight: any;

	export let bigScreen: boolean = false;
	$: bigScreen = innerWidth > 640;
</script>

<svelte:window bind:innerWidth bind:innerHeight />
<svelte:head>
	<title>Home | Polynomial Trade</title>
	<link rel="preload" as="image" href="scwallet/smart-contract-wallet-1.webp" />
	<link rel="preload" as="image" href="scwallet/succes-shield-1.webp" />
	<link rel="preload" as="image" href="scwallet/wallet-icon.webp" />
</svelte:head>

<MarketsMobile />

<Portfolio />
